import React from 'react';
import { Col } from 'reactstrap';
import { node } from 'prop-types';

const propTypes = {
  children: node.isRequired,
};

const LayoutLeftCol = ({ children, ...rest }) => (
  <Col lg="8" {...rest}>
    {children}
  </Col>
);

LayoutLeftCol.propTypes = propTypes;
export default LayoutLeftCol;
